(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/brands/assets/javascripts/brands-guards.js') >= 0) return;  svs.modules.push('/components/ui/brands/assets/javascripts/brands-guards.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (svs) {
  'use strict';

  svs.ui = svs.ui || {};
  svs.ui.brands = svs.ui.brands || {};
  svs.ui.brands.guards = svs.ui.brands.guards || {};
  var guards = {
    'lotto onsdag': 'lotto',
    'lotto-onsdag': 'lotto',
    'lotto-lordag': 'lotto',
    'lotto lordag': 'lotto',
    skrapkryss: 'skrap-kryss',
    skrappyramid: 'skrapspel',
    skrapkeno: 'keno',
    skraplotto: 'lotto',
    'skrap-lotto': 'lotto',
    'skrap-keno': 'keno',
    'skrap-familjen': 'skrapspel',
    'skrap-pac-man': 'skrap-pacman',
    skrapbingo: 'skrap-bingo',
    skrapmatcha: 'skrap-matcha',
    skrapstjarna: 'skrapspel',
    mixen: 'oddset',
    langen: 'oddset',
    sportsbook: 'oddset',
    dubbeltriss: 'dubbel-triss',
    '17-eller-mer': '17ellermer',
    '3-i-rad': '3irad',
    'mitt-emellan': 'mittemellan',
    minitriss: 'mini-triss',
    'triss-familjen': 'triss',
    'triss-30': 'triss',
    'triss-40': 'triss',
    'triss-90': 'triss',
    'triss-150': 'triss',
    'triss-premium': 'triss',
    netcasino: 'casino',
    'live casino': 'live-casino'
  };

  svs.ui.brands.guards.guard = function (brand) {
    var match = brand.trim().replace(/[ÅÄåä]/g, 'a').replace(/[Öö]/g, 'o').replace(/Éé/g, 'e').replace(/ /g, '-').replace(/[^A-Za-z0-9_-]/g, '').toLowerCase();

    if (guards[match]) {
      match = guards[match];
    }

    return match;
  }; 


  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = svs.ui.brands.guards;
  }
})(svs);
 })(window);